import './ContactUs.less';
import {Button, Form, Input, notification} from 'antd';
import locationIcon from '../../assets/icons/locationIcon.png';
import emailIcon from '../../assets/icons/Envelope.png';
import phoneIcon from '../../assets/icons/phoneIcon.png';
import linkedinIcon from '../../assets/icons/Social Media.png';
import shape from '../../assets/Shape.png';
import {generateRules} from '../Home/Home';
import TextArea from 'antd/es/input/TextArea';
import {useState} from 'react';
import {openNotification} from '../../Components/MainFormWithSlider/MainFormWithSlider';
import axios from 'axios';
import {useForm} from 'antd/es/form/Form';
import InfoModal from '../../Components/Modal/Modal';
const countryPhoneLengths: Record<string, number> = {
	'374': 8, // Armenia
	'1': 10, // USA
	'44': 10, // UK
	'33': 9, // France
	'49': 11, // Germany
	'7': 10, // Russia
	'91': 10, // India
	'61': 9, // Australia
	'81': 10, // Japan
	'31': 9
};
const ContactUs: React.FC = () => {
	const [loading, setLoading] = useState(false);
	const [api, contextHolder] = notification.useNotification();
	const [form] = useForm();

	// Define your form fields inside the component so you have access to `form`
	const formFields = [
		{
			name: 'name',
			rules: generateRules('fullName', 'Full Name'),
			input: <Input placeholder="Full Name" className="default-input" />,
			fullWidth: true
		},
		{
			name: 'email',
			rules: generateRules('email', 'email address'),
			input: <Input placeholder="Email Address" className="default-input" />
		},
		{
			name: 'subject',
			rules: generateRules('subject', 'subject'),
			input: <Input placeholder="Subject" className="default-input" />
		},
		{
			name: 'phone',
			rules: [
				{required: true, message: 'Please enter your phone!'},
				{
					pattern: /^\+?\d+$/,
					message: 'Please enter a valid phone number!'
				}
			],
			input: <Input placeholder="Phone Number" className="default-input" />
		},
		{
			name: 'brand',
			rules: generateRules('brand', 'brand'),
			input: <Input placeholder="Company Name" className="default-input" />
		},
		{
			name: 'message',
			isTextArea: true,
			rules: generateRules('message', 'message'),
			input: <TextArea rows={4} style={{resize: 'none'}} placeholder="Your message" />
		}
	];

	const renderFormItems = () =>
		formFields.map(item => (
			<Form.Item
				className={
					item.fullWidth
						? 'form-item-full-width'
						: item.isTextArea
							? 'form-item-textarea'
							: 'form-item'
				}
				key={item.name}
				name={item.name}
				validateTrigger="onBlur"
				rules={item.rules}>
				{item.input}
			</Form.Item>
		));
	const handleSendMessage = async (body: any) => {
		try {
			setLoading(true);

			const res = await axios.post('/send-email.php', body, {
				headers: {
					'Content-Type': 'application/json'
				}
			});

			if (res?.data?.success) {
				InfoModal({
					customText:
						'Your form has been successfully submitted. We have received your information and will review it shortly.',
					title: 'Thank you !'
				});

				form.resetFields();
			} else {
				openNotification(api, 'error');
			}
		} catch (err) {
			console.log(err, 'axios error');
			openNotification(api, 'error');
		} finally {
			setLoading(false);
		}
	};
	return (
		<div className="contact-us-container">
			<div className="contact-us-content">
				<div className="main-container">
					<div className="header-container">
						<div className="contact-us-header">
							<div className="contact-us-header-main">
								<p>CONTACT US</p>
							</div>
							<div className="contact-us-subheader">
								<p>Have a project in mind? We're here to help bring your ideas to life.</p>
							</div>
							<div className="contact-us-header-description">
								<span>
									Whether you're looking for cutting-edge technology solutions or need
									expert advice on SWIFT services, our team is ready to assist you.{' '}
									<span style={{fontWeight: 'bold'}}>Get in touch today</span> to discuss
									how we can work together to achieve your goals. We look forward to hearing
									from you!
								</span>
							</div>
						</div>
					</div>
					{contextHolder}
					<div className="image-form-container">
						<div className="image-main-container">
							<div className="contact-block">
								<div className="contact-info">
									<img className="shape" src={shape} alt="" />
									<p>Get in touch</p>
									<div className="contact-items">
										<div className="contact-item">
											<div className="contact-item-icon-block">
												<img src={emailIcon} alt="" />
											</div>
											<div className="contact-item-text-block">
												<p className="contact-block-title">Email Us</p>
												<a href="mailto:info@itg.am" className="contact-block-value">
													info@itg.am
												</a>
											</div>
										</div>
										<div className="contact-item">
											<div className="contact-item-icon-block">
												<img src={phoneIcon} alt="phone icon" />
											</div>
											<div className="contact-item-text-block">
												<p className="contact-block-title">Phone Number</p>
												<a href="tel:+374 60 370044" className="contact-block-value">
													+374 60 370044
												</a>
											</div>
										</div>
										<div className="contact-item">
											<div className="contact-item-icon-block">
												<img src={locationIcon} alt="location icon" />
											</div>
											<div className="contact-item-text-block" style={{gap: 'unset'}}>
												<p className="contact-block-value-span">
													7 Koryun str., off. 3,
												</p>
												<p className="contact-block-value-span">
													0025, Yerevan, Armenia.
												</p>
											</div>
										</div>
									</div>
								</div>
								<div className="contact-block-connect">
									<div className="connect-title">
										<p>Connect with us:</p>
									</div>
									<div className="linkedin-icon">
										<a href="https://www.linkedin.com/company/information-technology-gateways/about/">
											<img src={linkedinIcon} alt="linkedin icon" />
										</a>
									</div>
								</div>
							</div>
						</div>
						<div className="form-container">
							<div className="contact-us-form">
								<Form
									form={form}
									name="contact-form"
									layout="vertical"
									initialValues={{remember: true}}
									onFinish={handleSendMessage}
									autoComplete="off">
									<div className="contact-form-container">{renderFormItems()}</div>
									<Form.Item className="submit-btn-container">
										<Button
											disabled={loading}
											type="primary"
											htmlType="submit"
											className="form-submit-button">
											Send Message
										</Button>
									</Form.Item>
								</Form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ContactUs;
